<div class="demo-banner" *ngIf="isDemo">
  <span class="demo-badge">Demo</span>
  <span class="demo-text">This is a demo website for testing and preview purposes</span>
</div>
